/**
 * Schema for build/Show SPA search params.
 *
 * This is the single source of truth for URL search parameters used by the
 * build page.
 */
export interface BuildSearchParams {
  /** Job UUID. When present, opens the step drawer to this job. */
  jid?: string;
  /** Step UUID. When present, opens the step drawer to this step. */
  sid?: string;
  /** Controls whether the drawer is visible. Set to "false" to suppress opening. */
  open?: string;
  /** Which tab is active inside the job drawer (e.g. "output", "tests", "annotations"). */
  tab?: string;
  /** Which sub-tab is active on the annotations page: "build" or "jobs". */
  annotations_tab?: string;
}

/**
 * Parse a bag of unknown values into validated `BuildSearchParams`.
 *
 * Non-string values are silently dropped; unknown keys are stripped.
 */
export function parseBuildSearch(input: Record<string, unknown>): BuildSearchParams {
  return {
    jid: typeof input.jid === "string" ? input.jid : undefined,
    sid: typeof input.sid === "string" ? input.sid : undefined,
    open: typeof input.open === "string" ? input.open : undefined,
    tab: typeof input.tab === "string" ? input.tab : undefined,
    annotations_tab: typeof input.annotations_tab === "string" ? input.annotations_tab : undefined,
  };
}
